import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a9 9 0 0 1 8.497 6.025l-8.497 2.975v-9","fill":"currentColor","stroke":"none","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}]]

const IconPercentage20 = createReactComponent('outline', 'percentage-20', 'Percentage20', __iconNode);

export default IconPercentage20;